import EL, { HTMLELEMENT } from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import HEADING from '../../DOM/heading/HEADING.js';
import TEXTBLOCK from '../../DOM/div/TEXTBLOCK/TEXTBLOCK.js';
import BUTTONGROUP from '../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
// Model Structure
export const headerAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const headerData = makeDataStruct([]);
export const headerModel = makeStruct([
    ['attributes', headerAttr],
    ['data', headerData]
]);
// Simplified Model
export function header(className, name) {
    return {
        attributes: headerAttr(className, name),
        data: headerData()
    };
}
export default class HEADER extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.HEADER, model);
    }
    addHeading(model) {
        return this.addChild(new HEADING(this, model));
    }
    addTextblock(model) {
        return this.addChild(new TEXTBLOCK(this, model));
    }
    addButtonGroup(model) {
        return this.addChild(new BUTTONGROUP(this, model));
    }
}
